import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

ReactDOM.render(
  <Auth0Provider
    domain='dev-1ofnhtfv.us.auth0.com'
    clientId='2acNQq9rETuf8NvwMYA7p8FaSC3BK83D'
    redirectUri='https://thetable301.netlify.app/'
  >
    <App />
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
